import styled from 'styled-components';

const ContainerStyled = styled.div`
  margin: 0px 15px 32px;
  > img {
    width: 100%;
  }

  @media (min-width: 769px) {
    margin: 0px auto 48px;
  }
`;

export default ContainerStyled;
